module.exports = __webpack_public_path__ + "assets/asian_disabled-371c44.svg";